import gql from 'graphql-tag';

export const deleteChargeCode = gql(/* GraphQL */ `
mutation deleteChargeCode(
  $deleteChargeCodeRequest: DeleteChargeCodeRequest!
) {
  deleteChargeCode(
    deleteChargeCodeRequest: $deleteChargeCodeRequest
  )
}
`);